import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

// Configurações de debug para desenvolvimento
if (import.meta.env.DEV) {
  console.log('🚀 Aplicação iniciada em modo de desenvolvimento');
  console.log('🔧 Debug habilitado');
}

createRoot(document.getElementById("root")!).render(<App />);
